import { z } from "zod";

export const PostCancelBillingRequestBodySchema = z.object({
  id: z.string(),
});

export type PostCancelBillingRequestBodyType = z.infer<
  typeof PostCancelBillingRequestBodySchema
>;
